import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import FilterTag from "../FilterTag";
import t from "@zendesk/client-i18n-tools";

export default class YesNoFilter extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.bool,
  };

  render() {
    const { onClick, type, value } = this.props;

    return (
      <FilterTag
        type={type}
        onClick={onClick}
        value={
          value
            ? t("knowledge-verification.yes")
            : t("knowledge-verification.no")
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/YesNoFilter/index.js